import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { loginUser } from "../utils/auth";
import API_BASE from "../config"; // ✅ Correct import

function Login() {
  const navigate = useNavigate();

  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}/login.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await response.json();
      setLoading(false);

      if (!data.success) {
        setMsg("❌ " + data.message);
        return;
      }

      // Backend does NOT send a token, so use fallback
      loginUser(data.token ?? "local_token", data.user);

      setMsg("✅ Login successful!");

      setTimeout(() => navigate("/courses"), 300);

    } catch (err) {
      console.error(err);
      setMsg("❌ Server error. Try again.");
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">

      <style>{`
        .auth-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          background: linear-gradient(to right, #faa9a9, #eec76b, #90e8f4);
          font-family: 'Segoe UI';
        }
        form {
          background: #fff;
          padding: 35px 30px;
          border-radius: 12px;
          max-width: 400px;
          width: 100%;
          box-shadow: 0 8px 24px rgba(0,0,0,0.2);
        }
        input {
          width: 100%;
          padding: 12px;
          border-radius: 8px;
          border: 1px solid #ccc;
          margin-bottom: 15px;
          font-size: 14px;
        }
        button {
          width: 100%;
          padding: 12px;
          border-radius: 8px;
          background: linear-gradient(to right, #fba800, #f70077);
          color: white;
          font-weight: bold;
          border: none;
          cursor: pointer;
        }
        .msg {
          margin-top: 15px;
          text-align: center;
          font-weight: bold;
        }
      `}</style>

      <h2>Login</h2>

      <form onSubmit={handleSubmit} autoComplete="off">
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
        />

        <input
          type="password"
          name="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>

      {msg && <div className="msg">{msg}</div>}

      <p>
        Don't have an account? <Link to="/signup">Signup here</Link>
      </p>
    </div>
  );
}

export default Login;
